/**
 * localStorage prefix for the daily AI briefing (AiBriefingCard caches the text, its
 * follow-up items and the "Hide" flag; BriefingWorkerSections its backfill marker).
 * Every key starts with this, keyed by tenant + user + day. The briefing names
 * customers and money, so clearPerUserDeviceState sweeps the whole prefix at sign-out —
 * the next person on a shared browser must never read it (KAN-946 security review).
 */
export const BRIEFING_STORAGE_PREFIX = 'crewvex.briefing.';
